import { render, staticRenderFns } from "./TheEnforcementProceedings.vue?vue&type=template&id=705c5b6b&"
import script from "./TheEnforcementProceedings.vue?vue&type=script&lang=js&"
export * from "./TheEnforcementProceedings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports